export default __webpack_public_path__ + "static/media/NonPassBraid.04f5bc1e.png";